import React, { Component } from 'react'
import CaseAdd from '../CaseAdd'

export default class extends Component {
  render() {
    return (
      <CaseAdd
        {...this.props}
        type="case"
        id={this.props.params.id}
        propertyId={this.props.location.query.propertyId || ''}
        isFromShuijing={!!this.props.location.query.isFromShuijing}
        draftId={this.props.location.query.draftId || ''}
      />
    )
  }
}
